<template>
  <section class="Join-movement-section mb-10">
    <div class="container p-5">
      <div class="row">
        <div class="col-sm-12">
          <h1 class="section-title">Join the movement & get started today</h1>
          <p class="section-paragraph">
            Unleash the power of AI to make informed product decisions and drive e-commerce success.
          </p>
        </div>
        <div
          v-if="!isScheduleCall"
          class="shopfiy-hero-container d-flex align-items-center justify-content-center pt-5"
        >

        </div>
        <div
          v-else
          class="shopfiy-hero-container d-flex align-items-center justify-content-center pt-5"
        >
        
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isScheduleCall: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped></style>
